module.exports = __webpack_public_path__ + "static/media/prostitutionArticle1.0f42d519.jpg";